import {dateKey} from '../modules/sales/salesModel';
export {dateKey};
const iso=d=>d.toISOString().slice(0,10);
export function periodRange(period,timeZone,now=new Date(Date.now())) {
 const today=dateKey(now,timeZone); if(!today)return {from:'',to:''};
 const day=new Date(today+'T12:00:00Z'),start=new Date(day),end=new Date(day);
 if(period==='clear')return {from:'',to:''};
 if(period==='this_week'||period==='last_week'){start.setUTCDate(day.getUTCDate()-((day.getUTCDay()+6)%7)-(period==='last_week'?7:0));end.setTime(start.getTime());end.setUTCDate(start.getUTCDate()+6);}
 if(period==='this_month'||period==='last_month'){start.setUTCDate(1);if(period==='last_month')start.setUTCMonth(start.getUTCMonth()-1);end.setTime(start.getTime());end.setUTCMonth(start.getUTCMonth()+1,0);}
 return {from:iso(start),to:iso(end)};
}
export const workDate=row=>row.endTime||row.end||row.completedAt;
export const validRange=range=>!range.from||!range.to||range.from<=range.to;
export function inPeriod(row,range,timeZone){if(!timeZone||!validRange(range))return false;const day=dateKey(workDate(row),timeZone);return !!day&&(!range.from||day>=range.from)&&(!range.to||day<=range.to);}
